import React from 'react';

import { components } from 'react-select';
import { dropdownIndicatorStyles } from './styles';

const DropdownIndicator = innerProps => (
  <components.DropdownIndicator {...innerProps}>
    <span style={dropdownIndicatorStyles} className="icon icon-arrow-down" />
  </components.DropdownIndicator>
);

export default DropdownIndicator;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/enhanced_select/dropdown_indicator.jsx